import React, { Component } from 'react';
import SideMenuItem from './sidemenu/SideMenuItem';
import $ from 'jquery';

export default class SideBar extends Component {

  constructor() {
    super();

    this.state = {
      navigation: this.getNavigation()
    }
  }

  closeSideMenu() {
    $('.dashboard-side').addClass('collapsed');
    $('.dashboard-main').addClass('full-width');
    $('.dashboard-menu-top').addClass('fullsize');
    $('.breadcrumb').addClass('small');
    $('.collapse-menu').hide();
    $('#collapse').show();
    $('.sub-nav').css({ 'display': 'none' });
    $('.sideMenuList li a span').css({ 'display': 'none' });
    $('#collapse').css({ 'position': 'relative', 'height': '40px' });
    $('.sub-nav').addClass('toggled-menu');
    $('.arrow').hide();
    $('.dashboard-main ').click(function () {
      $('.toggled-menu').css({ 'display': 'none' });
    });
    $('.toggled-menu li').click(function () {
      $('.toggled-menu').css({ 'display': 'none' });
    });
    // let sideMenu = function () {
    //   let el = $('.sideMenuList li');
    //   el.hover(function () {
    //     let elm = $(this);
    //     elm.find('.toggled-menu').addClass('visible');
    //   }, function () {
    //     let elm = $(this);
    //     elm.find('.toggled-menu').removeClass('visible');
    //   });
    // }
    // sideMenu();
  }

  showSideMenu() {
    $('.dashboard-side').removeClass('collapsed');
    $('.dashboard-main').removeClass('full-width');
    $('.dashboard-menu-top').removeClass('fullsize');
    $('.breadcrumb').removeClass('small');
    $('.collapse-menu').show();
    $('#collapse').hide();
    $('.sub-nav').css({ 'display': 'none' });
    $('.sub-nav').removeClass('toggled-menu');
    $('.sideMenuList li a span').css({ 'display': 'inline-block' });
    // $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
  }


  componentDidMount() {
    if ($(window).width() < 1440) {
      this.closeSideMenu();
      $('#collapse').css({ 'display': 'block', 'margin-top': '12px' });
      $('.arrow').hide();
    }
    if ($('.dashboard-side').hasClass('collapsed')) {
      $('.arrow').hide();
    } else {
      // $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
    }

    let toggleMenu = function () {
      let el = $('.sideMenuList').find('> li').find('> a');
      el.click(function () {
        let elm = $(this);
        let parentLi = elm.closest('li');

        parentLi.closest('ul').children().not(parentLi).each(function (index, li) {
          let $li = $(li);
          $li.find('.sub-nav').slideUp();
          $li.find('.arrow').removeClass('arrow-down');
        })

        // console.error(parentLi);

        elm.parent().find('.sub-nav').slideToggle();
        elm.parent().find('.arrow').toggleClass('arrow-down');

      });
      // $('.sideMenuList').find('.sub-nav').parent().find('a').append('<i class="fa fa-angle-left arrow" aria-hidden="true"></i>');
    }
    toggleMenu();
  }

  render() {

    let items = [];
    this.state.navigation.forEach((item, index) => {
      let key = 'side-menu-item-' + index;
      items.push(<SideMenuItem {...item} key={key} />)
    });
    return (
      <div className="dashboard-side">
        <div className="dash-logo"><img src={require("AdminApp/assets/img/logo.svg")} alt="" /></div>
        <div className="side-menu">
          <i id="collapse" onClick={this.showSideMenu} style={{
            color: '#fff'
          }} className="fa fa-bars" aria-hidden="true"></i>

          <p className="collapse-menu" onClick={this.closeSideMenu}>
            <i style={{
              color: '#fff'
            }} className="fa fa-angle-double-left" aria-hidden="true"></i>
            Collapse menu
        </p>

          <ul className="sideMenuList">
            {items}
          </ul>
        </div>
      </div>
    )
  }

  getNavigation() {
    return [
      {
        label: 'Dashboard',
        icon: 'tachometer',
        path: '/'
      },
      {
        label: 'KYC Journeys',
        icon: 'tachometer',
        path: '/kyc/journeys'
        // children: [
        //   {
        //     label: 'Dashboard',
        //     icon: 'tachometer',
        //     path: '/kyc'
        //   },
        //   {
        //     label: 'Requests',
        //     icon: 'list',
        //     path: '/kyc/requests'
        //   }
        // ]
      },
      {
        label: 'Users',
        icon: 'users',
        path: null,
        children: [
          {
            label: 'All Users',
            path: '/users/all-users',
            icon: 'users'
          }, {
            label: ' User Devices',
            path: '/users/user-devices',
            icon: 'laptop'
          }, {
            label: ' Admins',
            path: '/users/admins',
            icon: 'user-plus'
          }
        ]
      },
      {
        label: 'Cards',
        icon: 'credit-card',
        path: '/cards'
      },
      {
        label: 'Transactions',
        icon: 'exchange',
        path: '/transaction'
      },
      // {
      //   label: 'Card Management',
      //   // icon: 'credit-card',
      //   icon: 'credit-card-alt',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Card Types',
      //       path: '/card-management/card-types',
      //       icon: 'credit-card'
      //     }, {
      //       label: 'Card Categories',
      //       path: '/card-management/card-categories',
      //       icon: 'th'
      //     }, {
      //       label: 'Card Products',
      //       path: '/card-management/card-products',
      //       icon: 'product-hunt'
      //     },
      //     // {
      //     //   label: 'PAN Ranges',
      //     //   path: '/card-management/pan-ranges',
      //     //   icon: 'list'
      //     // }, {
      //     //   label: 'Serial No. Ranges',
      //     //   path: '/card-management/serial-ranges',
      //     //   icon: 'list'
      //     // }
      //   ]
      // },
      // {
      //   label: 'Analytics',
      //   icon: 'bar-chart',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Schools',
      //       path: '/analytics/schools',
      //       icon: 'university'
      //     },
      //     {
      //       label: 'Projects',
      //       path: '/analytics/projects',
      //       icon: 'rocket'
      //     },
      //     {
      //       label: 'Donations',
      //       path: '/analytics/donations',
      //       icon: 'money'
      //     },
      //     {
      //       label: 'Cards',
      //       path: '/analytics/cards',
      //       icon: 'credit-card',
      //       children: [
      //         {
      //           label: 'Activated cards',
      //           path: '/analytics/cards/activated',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Loaded cards',
      //           path: '/analytics/cards/loaded',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Card Spending',
      //           path: '/analytics/cards/spending',
      //           icon: 'line-chart'
      //         },
      //         {
      //           label: 'Card Expiration',
      //           path: '/analytics/cards/expiration',
      //           icon: 'line-chart'
      //         },
      //         // {
      //         //   label: 'Uplift',
      //         //   path: '/analytics/uplift',
      //         //   icon: 'arrow-up'
      //         // },
      //       ]
      //     },
      //     // {
      //     //   label: 'Cards',
      //     //   path: '/card-management/activated',
      //     //   icon: 'list',
      //     //   children: [
      //     //     {
      //     //       label: 'Issued Cards',
      //     //       path: '/card-management/activated',
      //     //       icon: 'power-off'
      //     //     },
      //     //     //  {
      //     //     //   label: 'Redeemed Cards',
      //     //     //   path: '/card-management/redeemed',
      //     //     //   icon: 'money'
      //     //     // },
      //     //     //  {
      //     //     //   label: 'Reloaded Cards',
      //     //     //   path: '/card-management/reloaded',
      //     //     //   icon: 'refresh'
      //     //     // },
      //     //     {
      //     //       label: 'Card Stock',
      //     //       path: '/card-management/stock',
      //     //       icon: 'database'
      //     //     }
      //     //   ]
      //     // },
      //     // {
      //     //   label: 'Promotions',
      //     //   path: '/analytics/promotions',
      //     //   icon: 'gift'
      //     // },
      //     {
      //       label: 'Customers',
      //       path: '/analytics/customers',
      //       icon: 'user'
      //     },
      //   ]
      // },
      {
        label: 'Content Management',
        icon: 'cog',
        path: null,
        children: [
          {
            label: 'Config',
            icon: 'cogs',
            path: '/config'
          },
          {
            label: 'Faq',
            icon: 'question-circle',
            path: '/faq'
          },
          {
            label: 'Countries',
            path: '/countries',
            icon: 'map'
          },
          {
            label: 'Currencies',
            path: '/currencies',
            icon: 'money'
          },
          {
            label: 'Transaction Categories',
            path: '/transaction-categories',
            icon: 'exchange'
          },
          {
            label: 'Transaction Merchant',
            path: '/transaction-merchant',
            icon: 'exchange'
          },
          {
            label: 'Merchant Category Code',
            path: '/merchant-category-code',
            icon: 'barcode'
          },

        ]
      },
      // {
      //   label: 'OnePay',
      //   icon: 'star',
      //   path: null,
      //   children: [
      //     {
      //       label: 'Schools',
      //       icon: 'university',
      //       path: '/schools'
      //     },
      //     {
      //       label: 'Projects',
      //       icon: 'rocket',
      //       path: '/projects'
      //     },
      //     {
      //       label: 'Donation Group',
      //       icon: 'handshake-o',
      //       path: '/donation-group'
      //     }
      //   ]
      // },
      {
        label: 'Reports',
        icon: 'file',
        path: null,
        children: [
          {
            label: 'Totals',
            path: '/reports/totals',
            icon: 'globe'
          },
          // {
          //   label: 'Schools',
          //   path: '/reports/schools',
          //   icon: 'university'
          // },
          // {
          //   label: 'Projects',
          //   path: '/reports/projects',
          //   icon: 'rocket'
          // },
          {
            label: 'Cards',
            path: '/reports/cards',
            icon: 'credit-card'
          },
          // {
          //   label: 'Donations',
          //   path: '/reports/donations',
          //   icon: 'money'
          // },
          // {
          //   label: 'Donations',
          //   path: '/reports/distributed-donations',
          //   icon: 'money'
          // },
          // {
          //   label: 'Cardholders',
          //   path: '/reports/cardholders',
          //   icon: 'balance-scale'
          // },
          // {
          //   label: 'Fees',
          //   path: '/reports/fees',
          //   icon: 'balance-scale'
          // },
          // {
          //   label: 'Gift Aid',
          //   path: '/reports/giftaid',
          //   icon: 'balance-scale'
          // },
        ]
      },
      {
        label: 'Legal',
        icon: 'balance-scale',
        path: null,
        children: [{
          label: 'Terms and Conditions',
          path: '/terms',
          icon: 'balance-scale'
        }, {
          label: 'Privacy Policy',
          path: '/privacy',
          icon: 'balance-scale'
        },]
      },
      {
        label: 'Dictionary',
        path: '/dictionary',
        icon: 'globe'
      }
      // {
      //   label: 'PUSH Notifications',
      //   icon: 'bell',
      //   path: '/push-notifications',
      //   children: [
      //     {
      //       label: 'Push Dashboard',
      //       path: '/push-notifications',
      //       icon: 'bell'
      //     },
      //     {
      //       label: 'Send new',
      //       path: '/push-notifications/add-new',
      //       icon: 'plus'
      //     }, {
      //       label: 'Customer Groups',
      //       path: '/push-notifications/customer-groups',
      //       icon: 'users'
      //     },
      //     {
      //       label: 'Sent Messages',
      //       path: '/push-notifications/sent-messages',
      //       icon: 'paper-plane'
      //     },
      //     // {
      //     //   label: 'PAN Ranges',
      //     //   path: '/card-management/pan-ranges',
      //     //   icon: 'list'
      //     // }, {
      //     //   label: 'Serial No. Ranges',
      //     //   path: '/card-management/serial-ranges',
      //     //   icon: 'list'
      //     // }
      //   ]
      // },

    ];
  }
}



// WEBPACK FOOTER //
// ./src/layouts/elements/SideBar.js